import { IAIModelRepository, AIModelEntity, ResponseValueObject } from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class AIModelRepository implements IAIModelRepository {
  private readonly endpoint = '/ai/models';

  async getAll(): Promise<ResponseValueObject<AIModelEntity[]>> {
    const response = await axiosClient.get<ResponseValueObject<AIModelEntity[]>>(this.endpoint);
    return response.data;
  }
}
